import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';

export enum EntityCreationFeatureType {
  REGISTRATION_TABLE = 'REGISTRATION_TABLE',
  LEGACY_REGISTRATION_TABLE = 'LEGACY_REGISTRATION_TABLE',
  ADD_FROM_SPREADSHEET_TO_REGISTRATION_TABLE = 'ADD_FROM_SPREADSHEET_TO_REGISTRATION_TABLE',
  /**
   * `IMPORT_FROM_SPREADSHEET` gates import flows *except* importing into the registry, which is gated by
   * excluding SSIs in `ChooseImportIntoRegistryModalPane`.
   */
  IMPORT_FROM_SPREADSHEET = 'IMPORT_FROM_SPREADSHEET',
}

/**
 * Additional entity types that are not `TagSchemaItemType`s but force their own special entity creation
 * flows.
 */
export enum AdditionalCreatableEntityType {
  TRIAL_SAMPLE = 'TRIAL_SAMPLE',
}

export type CreatableEntityType = TagSchemaItemType | AdditionalCreatableEntityType;
